/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export default class TipoSolucao {

  constructor () {
    this.tp_solucao_id = uuidV4();
    this.descricao= '';
    this.titulo= '';
    this.imagens= [];
    this.urls_imagem= [];
  }
}
